import Vue from 'vue'
import 'xe-utils'
import VueI18n from 'vue-i18n'
import zhCN from './i18n/lang/zh-CN'
import enUS from './i18n/lang/en-US'

const messages = {
  zh_CN: zhCN,
  en_US: enUS
}

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh_CN',
  messages,
})

export default i18n
